<template>
  <div class="t-page">
    <!-- 左侧导航栏 -->
    <div class="question-nav">
      <div class="title">
        <div class="exam-name">{{ exam.title }}</div>
        <div class="exam-time">Exam Duration: {{ exam.duration }} minutes</div>
        <div :class="['timer', minutes > 10 ? 'warning' : 'danger']">{{ time }}</div>
      </div>
      <div class="question-nav-box">
        <div class="nav-title">
          <span>Question Navigation</span>
          <span>Total: {{ questions.length }} questions</span>
        </div>
        <div class="question-grid">
          <div
            :class="[
              'question-number',
              num - 1 === index ? 'current' : null,
              finishedList.includes(num - 1) ? 'answered' : null,
              markedList.includes(num - 1) ? 'marked' : null
            ]"
            v-for="num in questions.length"
            :key="num"
            @click="choosed(num - 1)"
          >
            <div>{{ num }}</div>
          </div>
        </div>
        <div class="legend">
          <div class="legend-item">
            <div class="legend-color current-legend"></div>
            <span>Current Question</span>
          </div>
          <div class="legend-item">
            <div class="legend-color answered-legend"></div>
            <span>Answered</span>
          </div>
          <div class="legend-item">
            <div class="legend-color marked-legend"></div>
            <span>Flagged Question</span>
          </div>
        </div>
      </div>
      <div class="nav-footer">
        <button class="btn btn-full" v-show="!markedList.includes(index)" @click="mark">
          <i class="el-icon-s-flag"></i> Mark Question
        </button>
        <button class="btn btn-full" v-show="markedList.includes(index)" @click="remark" style="background: #ff9800;">
          <i class="el-icon-collection-tag"></i> Unmark
        </button>
        <button class="btn btn-outline btn-full" @click="submitPaper">
          <i class="el-icon-s-promotion"></i> Submit Paper
        </button>
      </div>
    </div>

    <!-- 右侧题目区 -->
    <div class="question">
      <div class="opration_box">
        <div class="question-progress">
          <span id="currentQuestion">{{ index + 1 }}</span>/<span id="totalQuestions">{{ questions.length }}</span>
          <span v-show="question.type === 'single_choice'" class="question-type">SINGLE-CHOICE</span>
          <span v-show="question.type === 'true_false'" class="question-type">TRUE/FALSE</span>
          <span v-show="question.type === 'multiple_choice'" class="question-type">MULTIPLE-CHOICE</span>
        </div>
        <div class="action-buttons">
          <button class="btn btn-outline" id="prevBtn" @click="previous">
            <i class="el-icon-arrow-left"></i> Previous
          </button>
          <button class="btn" id="nextBtn" @click="next">
            Next <i class="el-icon-arrow-right"></i>
          </button>
        </div>
      </div>
      <div class="question_details">
        <h2 class="question-title">Question <span>{{ index + 1 }}</span></h2>
        <div class="question-text">{{ question.stem }}</div>
        <div class="options-container">
          <!-- 判断题 -->
          <div v-if="question.type === 'true_false'">
            <div :class="['option', answerChoose[0] === 0 ? 'selected' : null]" @click="choose('true_false', 0)">
              <div class="option-marker">A</div>
              <div class="option-text">√</div>
            </div>
            <div :class="['option', answerChoose[0] === 1 ? 'selected' : null]" @click="choose('true_false', 1)">
              <div class="option-marker">B</div>
              <div class="option-text">×</div>
            </div>
          </div>
          <!-- 单选题 -->
          <div v-if="question.type === 'single_choice'">
            <div
              :class="['option', answerChoose[0] === idx ? 'selected' : null]"
              @click="choose('single_choice', idx)"
              v-for="(item, idx) in question.content.options"
              :key="idx"
            >
              <div class="option-marker">{{ idx | getLetter }}</div>
              <div class="option-text">{{ item }}</div>
            </div>
          </div>
          <!-- 多选题 -->
          <div v-if="question.type === 'multiple_choice'">
            <div
              :class="['option', answerChoose.includes(idx) ? 'selected' : null]"
              @click="choose('multiple_choice', idx)"
              v-for="(item, idx) in question.content.options"
              :key="idx"
            >
              <div class="option-marker">{{ idx | getLetter }}</div>
              <div class="option-text">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findQuestionsByExamId, getExam, submit, checkExhausted } from '@/api/exam'

export default {
  name: 'ExamTaking',
  data() {
    return {
      examId: '',
      exam: {},
      questions: [],
      question: {},
      index: 0,
      time: '00:00:00',
      minutes: 0,
      worker: null,
      answers: [],
      answerChoose: [],
      finishedList: [],
      markedList: [],
      startedAt: null,
      remainingTime: 0,

      // 防作弊
      leaveCount: 0,
      autoSubmit: false,
      isSubmitting: false,
    }
  },
  async created() {
    // 未登录则关闭窗口
    if (!this.$store.state.client.user.id) {
      this.$message.error('Please log in first.')
      setTimeout(() => window.close(), 500)
      return
    }
    this.examId = this.$route.params.id
    await this.checkExhausted()
  },
  async mounted() {
    await this.findQuestionsByExamId()
    await this.getExam()
    this.index = 0
    this.question = this.questions[this.index]

    // 全屏
    this.requestFullscreen()

    // 如果全屏被阻止，用户点击时再次尝试（只触发一次）
    const handleClick = () => {
      if (!document.fullscreenElement) {
        this.requestFullscreen()
      }
      document.removeEventListener('click', handleClick)
    }
    document.addEventListener('click', handleClick)

    // 防作弊监听
    window.addEventListener('blur', this.handleWindowBlur)
    window.addEventListener('focus', this.handleWindowFocus)
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    document.addEventListener('keydown', this.handleKeyDown)
    document.addEventListener('contextmenu', this.handleContextMenu)
    document.addEventListener('copy', this.handleCopyPaste)
    document.addEventListener('paste', this.handleCopyPaste)

    // 窗口关闭/刷新拦截
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy() {
    // 移除监听
    window.removeEventListener('blur', this.handleWindowBlur)
    window.removeEventListener('focus', this.handleWindowFocus)
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
    document.removeEventListener('keydown', this.handleKeyDown)
    document.removeEventListener('contextmenu', this.handleContextMenu)
    document.removeEventListener('copy', this.handleCopyPaste)
    document.removeEventListener('paste', this.handleCopyPaste)
    window.removeEventListener('beforeunload', this.handleBeforeUnload)

    if (this.worker) {
      this.worker.terminate()
      this.worker = null
    }
  },
  methods: {
    // ========== 全屏方法 ==========
    requestFullscreen() {
      try {
        const el = document.documentElement
        if (el.requestFullscreen) {
          el.requestFullscreen().catch(() => {})
        } else if (el.webkitRequestFullscreen) {
          el.webkitRequestFullscreen()
        } else if (el.mozRequestFullScreen) {
          el.mozRequestFullScreen()
        } else if (el.msRequestFullscreen) {
          el.msRequestFullscreen()
        }
      } catch (e) {
        // 忽略
      }
    },

    // ========== 数据请求 ==========
    async checkExhausted() {
      try {
        const { data: { data, isSuccess } } = await checkExhausted(this.examId)
        if (isSuccess && !data) {
          this.$message.warning('This exam has ended.')
          setTimeout(() => window.close(), 500)
        } else if (!isSuccess) {
          this.$message.error('Failed to get exam status.')
          setTimeout(() => window.close(), 500)
        }
      } catch (e) {
        this.$message.error('Network error.')
        setTimeout(() => window.close(), 500)
      }
    },
    async findQuestionsByExamId() {
      try {
        const { data: { data, isSuccess } } = await findQuestionsByExamId({ examId: this.examId })
        if (isSuccess) {
          this.questions = data.map(item => {
            item.content = JSON.parse(item.content)
            if (['single_choice', 'multiple_choice', 'true_false'].includes(item.type)) {
              this.answers.push({
                examQuestionId: item.id,
                answerContent: { selected: [] }
              })
            } else if (item.type === 'fill_blank') {
              this.answers.push({
                examQuestionId: item.id,
                answerContent: { filled: [] }
              })
            }
            return item
          })
        } else {
          this.$message.error('Failed to load questions.')
          setTimeout(() => window.close(), 500)
        }
      } catch (e) {
        this.$message.error('Network error.')
        setTimeout(() => window.close(), 500)
      }
    },
    async getExam() {
      try {
        const { data: { data, isSuccess } } = await getExam({ id: this.examId })
        if (isSuccess && data) {
          this.exam = data[0]
          this.initTimer()
        } else {
          this.$message.error('Failed to load exam information.')
          setTimeout(() => window.close(), 500)
        }
      } catch (e) {
        this.$message.error('Network error.')
        setTimeout(() => window.close(), 500)
      }
    },

    // ========== 计时器 ==========
    initTimer() {
        this.startedAt = Date.now()
        const endTime = new Date(this.startedAt)
        endTime.setMinutes(endTime.getMinutes() + this.exam.duration)

        this.worker = new Worker('/workers/exam.worker.js')
        this.worker.postMessage({ type: 'CALCULATE', data: endTime.getTime() })

        this.worker.onmessage = (e) => {
            this.time = e.data.result
            this.minutes = e.data.minutes
            this.remainingTime = e.data.remainingTime
            if (e.data.finished) {
                this.worker.terminate()
                if (!this.autoSubmit) {
                    this.autoSubmit = true
                    // === 可配置部分 ===
                    const msg = 'Time is up! Your paper will be submitted automatically.'
                    const delay = 500 // 毫秒
                    this.$message({
                        message: msg,
                        type: 'error',
                        duration: 3000
                    })
                    setTimeout(() => {
                        this.doSubmitExam('Time is up')
                    }, delay)
                }
            }
        }
        this.worker.onerror = (error) => {
            console.error('Worker error:', error)
        }
    },

    // ========== 防作弊核心 ==========
    incrementCheatCount() {
        let leaveCount = 5
        if (this.autoSubmit) return
        this.leaveCount++
        this.$message.warning(`Detected leaving exam window (${this.leaveCount}/${leaveCount})`)

        if (this.leaveCount >= leaveCount) {
            this.autoSubmit = true
            // === 可配置部分 ===
            const msg = 'Exceeded maximum tab switches, system is auto-submitting your paper.'
            const delay = 1000 // 毫秒，给用户看到提示的时间
            // 显示提示（非阻塞）
            this.$message({
                message: msg,
                type: 'error',
                duration: 3000
            })
            setTimeout(() => {
                this.doSubmitExam('Exceeded tab switches')
            }, delay)
        }
    },

    handleWindowBlur() {
      this.incrementCheatCount()
      document.body.style.opacity = '0.8'
    },
    handleWindowFocus() {
      document.body.style.opacity = '1'
    },
    handleVisibilityChange() {
      if (document.hidden) {
        this.incrementCheatCount()
      } else {
        this.handleWindowFocus()
      }
    },
    handleFullscreenChange() {
      if (!document.fullscreenElement && !this.autoSubmit) {
        this.incrementCheatCount()
        this.requestFullscreen()
      }
    },

    // 键盘拦截
    handleKeyDown(e) {
      const ctrl = e.ctrlKey || e.metaKey
      const shift = e.shiftKey
      const key = e.key.toLowerCase()

      if (
        key === 'f12' ||
        (ctrl && shift && ['i', 'j', 'c'].includes(key)) ||
        (ctrl && ['u', 's', 'p'].includes(key)) ||
        (ctrl && shift && key === 'u')
      ) {
        e.preventDefault()
        this.$message.warning('Developer tools or source view is prohibited!')
        return false
      }
      if (ctrl && ['c', 'v'].includes(key)) {
        e.preventDefault()
        this.$message.warning('Copy or paste is prohibited!')
        return false
      }
      if (key === 'f5' || (ctrl && key === 'r')) {
        e.preventDefault()
        this.$message.warning('Page refresh is prohibited!')
        return false
      }
      // 拦截 Ctrl+W (关闭标签页)
      if (ctrl && key === 'w') {
        e.preventDefault()
        this.$message.warning('Closing tab is not allowed during exam!')
        return false
      }
      // Alt+F4 无法被完全拦截，但 beforeunload 会处理
      return true
    },

    handleContextMenu(e) {
      e.preventDefault()
      this.$message.warning('Right-click menu is prohibited!')
      return false
    },
    handleCopyPaste(e) {
      e.preventDefault()
      this.$message.warning('Copy or paste is prohibited.')
      return false
    },

    // ========== 窗口关闭拦截 ==========
    handleBeforeUnload(e) {
      // 如果已经提交，允许直接关闭
      if (this.autoSubmit) return

      // 显示警告提示
      const message = 'Are you sure you want to close? Your answers will not be saved.'
      e.preventDefault()
      e.returnValue = message
      // 提醒用户
      this.$message.warning('Closing the exam window will forfeit your progress.')
      // 记录一次作弊（但不增加自动提交计数，以免误触发）
      // 可以单独记录，这里只做提示
      return message
    },

    // ========== 答题交互 ==========
    choose(type, idx) {
      if (this.autoSubmit) return

      if (type === 'single_choice' || type === 'true_false') {
        this.$set(this.answerChoose, 0, idx)
        this.answers[this.index].answerContent.selected = this.answerChoose
      } else if (type === 'multiple_choice') {
        const pos = this.answerChoose.indexOf(idx)
        if (pos > -1) {
          this.answerChoose.splice(pos, 1)
        } else {
          this.answerChoose.push(idx)
        }
        this.answers[this.index].answerContent.selected = this.answerChoose
      }

      if (this.answers[this.index].answerContent.selected.length > 0) {
        if (!this.finishedList.includes(this.index)) {
          this.finishedList.push(this.index)
        }
      } else {
        const pos = this.finishedList.indexOf(this.index)
        if (pos > -1) this.finishedList.splice(pos, 1)
      }
    },

    mark() {
      if (!this.markedList.includes(this.index)) {
        this.markedList.push(this.index)
      }
    },
    remark() {
      const pos = this.markedList.indexOf(this.index)
      if (pos > -1) this.markedList.splice(pos, 1)
    },

    previous() {
      if (this.index > 0) {
        this.index--
        this.choosed(this.index)
      }
    },
    next() {
      if (this.index < this.questions.length - 1) {
        this.index++
        this.choosed(this.index)
      }
    },
    choosed(number) {
      this.index = number
      this.question = this.questions[this.index]
      if (['single_choice', 'multiple_choice', 'true_false'].includes(this.question.type)) {
        this.answerChoose = this.answers[this.index].answerContent.selected || []
      } else if (this.question.type === 'fill_blank') {
        this.answerChoose = this.answers[this.index].answerContent.filled || []
      }
    },

    // ========== 提交逻辑 ==========
    submitPaper() {
      if (this.autoSubmit) {
        this.$alert('Auto-submission already triggered, cannot submit again.', 'Tip')
        return
      }
      if (this.isSubmitting) return

      let message = 'Are you sure to submit?'
      if (this.finishedList.length < this.questions.length) {
        message = `There are still ${this.questions.length - this.finishedList.length} questions unanswered. Are you sure to submit?`
      }

      this.$confirm(message, 'Tip', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.doSubmitExam('User manually submitted')
      }).catch(() => {})
    },

    async doSubmitExam(reason) {
      if (this.isSubmitting) return
      this.isSubmitting = true

      const answers = JSON.parse(JSON.stringify(this.answers))
      for (const item of answers) {
        item.answerContent = JSON.stringify(item.answerContent)
      }

      const stopSpent = new Date()
      const timeSpent = Math.floor(Math.abs(stopSpent.getTime() - this.startedAt) / 1000)

      const obj = {
        examId: this.examId,
        answers,
        startedAt: new Date(this.startedAt).Format('yyyy-MM-dd hh:mm:ss'),
        submittedAt: stopSpent.Format('yyyy-MM-dd hh:mm:ss'),
        timeSpent
      }

      try {
        const { data: { isSuccess } } = await submit(obj)
        if (isSuccess) {
          this.$message.success('Submission successful! Window will close...')
          // ===== 新增：通知父页面 =====
            if (window.opener) {
                window.opener.postMessage({
                type: 'examSubmitted',
                examId: this.examId,
                success: true
                }, '*')
            }
          setTimeout(() => window.close(), 1000)
        } else {
          this.$message.error('Submission failed, please retry.')
          this.isSubmitting = false
        }
      } catch (err) {
        this.$message.error('Submission failed, please retry.')
        this.isSubmitting = false
      }
    }
  },
  filters: {
    getLetter(index) {
      return String.fromCharCode(65 + index)
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 991px) {
  .t-page {
    height: 100vh;
    display: flex;

    .question-nav {
      flex: 2;
      background: #f8f9fa;
      border-right: 1px solid #eaeaea;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .title {
        text-align: center;
        color: white;
        padding: 20px;
        background: rgba(199, 0, 11, 0.76);
        line-height: 1.9;

        .exam-name {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 5px;
        }
        .exam-time {
          font-size: 14px;
          opacity: 0.9;
        }
        .timer {
          margin-top: 10px;
          padding: 8px 15px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 30px;
          font-size: 18px;
          font-weight: bold;
          display: inline-block;
        }
        .timer.danger {
          background: rgba(244, 67, 54, 0.3);
          color: #f44336;
          animation: pulse 1s infinite;
        }
        .timer.warning {
          background: rgba(255, 193, 7, 0.3);
          color: #ff9800;
        }

        @keyframes pulse {
          0%   { opacity: 1; }
          50%  { opacity: 0.7; }
          100% { opacity: 1 }
        }
      }
      .question-nav-box {
        padding: 20px;

        .nav-title {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 15px;
          color: rgb(102, 102, 102);
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .question-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 12px;

          .question-number {
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #ffffff;
            border: 1px solid #eaeaea;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s;
            position: relative;

            &.current {
              background: rgba(199, 0, 11, 0.76);
              color: white;
              border-color: rgba(199, 0, 11, 0.76);
            }
            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
            }
            &.marked {
              background: rgba(255, 193, 7, 0.2);
              color: #ff9800;
              border-color: rgba(255, 193, 7, 0.3);
            }
            &.answered {
              background: rgba(76, 175, 80, 0.2);
              color: #4caf50;
              border-color: rgba(76, 175, 80, 0.3);
            }
            &.marked.current::after {
              content: '';
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: rgba(199, 0, 11, 0.76);
              position: absolute;
              right: -15px;
              top: 0px;
            }
            &.answered.current::after {
              content: '';
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: rgba(199, 0, 11, 0.76);
              position: absolute;
              right: -15px;
              top: 0px;
            }
            &.answered.marked {
              background: rgba(76, 175, 80, 0.2);
              color: #4caf50;
              border-color: rgba(76, 175, 80, 0.3);
            }
            &.answered.marked::before {
              content: '';
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: rgba(255, 193, 7, 0.616);
              position: absolute;
              right: -15px;
              top: 0px;
            }
            &.current.answered.marked::before {
              top: 15px;
            }
          }
        }
        .legend {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 20px;
          padding-top: 15px;
          border-top: 1px solid #eaeaea;

          .legend-item {
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #777777;

            .legend-color {
              width: 12px;
              height: 12px;
              border-radius: 3px;
              margin-right: 5px;
            }
            .current-legend {
              background: rgba(199, 0, 11, 0.76);
            }
            .answered-legend {
              background: rgba(76, 175, 80, 0.2);
              border: 1px solid rgba(76, 175, 80, 0.3);
            }
            .marked-legend {
              background: rgba(255, 193, 7, 0.2);
              border: 1px solid rgba(255, 193, 7, 0.3);
            }
          }
        }
      }
      .nav-footer {
        padding: 15px 20px;
        border-top: 1px solid #eaeaea;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .btn-full {
          width: 100%;
        }
        .btn {
          padding: 10px 20px;
          background: rgba(199, 0, 11, 0.76);
          color: white;
          border: none;
          border-radius: 6px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          outline-width: 0px;
          outline-color: none;
        }
        .btn:hover {
          background: rgba(199, 0, 11, 0.9);
          transform: translateY(-2px);
          box-shadow: 0 5px 10px rgba(199, 0, 11, 0.2);
        }
        .btn-outline {
          background: transparent;
          border: 1px solid rgba(199, 0, 11, 0.76);
          color: rgba(199, 0, 11, 0.76);
        }
        .btn-outline:hover {
          background: rgba(199, 0, 11, 0.1);
        }
      }
    }
    .question {
      flex: 8;

      .opration_box {
        padding: 20px 30px;
        border-bottom: 1px solid #eaeaea;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .question-progress {
          font-size: 16px;
          font-weight: 500;

          .question-type {
            display: inline-block;
            padding: 5px 12px;
            background: rgba(199, 0, 11, 0.1);
            color: rgba(199, 0, 11, 0.76);
            border-radius: 30px;
            font-size: 12px;
            font-weight: 500;
            margin-left: 10px;
          }
        }
        .action-buttons {
          display: flex;
          gap: 10px;

          .btn {
            padding: 10px 20px;
            background: rgba(199, 0, 11, 0.76);
            color: white;
            border: none;
            border-radius: 6px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            outline-width: 0px;
            outline-color: none;
          }
          .btn:hover {
            background: rgba(199, 0, 11, 0.9);
            transform: translateY(-2px);
            box-shadow: 0 5px 10px rgba(199, 0, 11, 0.2);
          }
          .btn-outline {
            background: transparent;
            border: 1px solid rgba(199, 0, 11, 0.76);
            color: rgba(199, 0, 11, 0.76);
          }
          .btn-outline:hover {
            background: rgba(199, 0, 11, 0.1);
          }
        }
      }
      .question_details {
        padding: 30px;
        overflow-y: auto;

        .question-title {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 25px;
          line-height: 1.5;

          span {
            color: rgba(199, 0, 11, 0.76);
          }
        }
        .question-text {
          font-size: 16px;
          line-height: 1.6;
          margin-bottom: 30px;
          background: #f8f9fa;
          padding: 20px;
          border-radius: 10px;
          border-left: 4px solid rgba(199, 0, 11, 0.76);
        }
        .options-container {
          margin-bottom: 30px;

          .option {
            display: flex;
            align-items: flex-start;
            padding: 15px 20px;
            margin-bottom: 15px;
            background: #f8f9fa;
            border: 2px solid #eaeaea;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.3s;
            &.selected {
              background: rgba(199, 0, 11, 0.05);
              border-color: rgba(199, 0, 11, 0.76);
            }

            .option-marker {
              width: 24px;
              height: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
              background: white;
              border: 2px solid #777777;
              border-radius: 50%;
              margin-right: 15px;
              flex-shrink: 0;
              font-weight: 600;
              font-size: 14px;
            }
            .option-text {
              flex: 1;
              font-size: 16px;
              line-height: 1.5;
            }
          }
        }
      }
    }
  }
}
</style>